import { useCallback, useState } from 'react';

import { useCustomerHasLiveScoring } from 'src/store/customer';

/**
 * Locks the insights-panel score when a gated user edits the copy.
 *
 * While locked, callers must stop feeding edited text into the scoring hook so
 * no re-score is fetched; the panel then renders the "Get score" / "Revert"
 * upsell instead of a live score. Customers with live scoring are never locked.
 */
export const useScoringLock = () => {
  const customerHasLiveScoring = useCustomerHasLiveScoring();
  const [isScoreLocked, setIsScoreLocked] = useState(false);

  // Returns true when the edit should be scored live (not locked).
  const handleEdit = useCallback(() => {
    if (customerHasLiveScoring) {
      return true;
    }
    setIsScoreLocked(true);
    return false;
  }, [customerHasLiveScoring]);

  const resetLock = useCallback(() => {
    setIsScoreLocked(false);
  }, []);

  return { isScoreLocked, handleEdit, resetLock };
};
